import { ActionButton, Persona, PersonaSize, Stack } from '@fluentui/react';

import { auth } from '../../App/firebase';
import { useAppSelector } from '../../App/store';
import { signOutIcon } from '../../utils/icons';

export default () => {
  const user = useAppSelector((state) => state.auth.user);
  const userdata = useAppSelector((state) => state.auth.userdata);

  if (!user || !userdata) return <></>;

  return (
    <Stack horizontal verticalAlign="center">
      <Persona
        text={userdata.retail?.name || user.displayName}
        secondaryText={
          userdata.admin
            ? "Yönetici"
            : userdata.rank in rankNames
            ? rankNames[userdata.rank]
            : "Kullanıcı"
        }
        showSecondaryText
        size={PersonaSize.size32}
        imageUrl={user.photoURL || undefined}
      />
      <ActionButton iconProps={signOutIcon} onClick={signOut} />
    </Stack>
  );
};

const signOut = () => auth.signOut();
const rankNames: { [key: string]: string } = {
  retail: "Mağaza",
  warehouse: "Depo",
};
